import React from 'react';
import '../../css/CategoryBar.css';

const CategoryBar = ({ activeCategory, setActiveCategory, setSearchTerm }) => {
    const categories = ['Popular', 'Basic', 'Advanced'];

    return (
        <div className="category-bar">
            <div className="search-container">
                <span className="bi bi-search"></span>
                <input
                    type="text"
                    placeholder="Search..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <div className="divider"></div>
            <div className="category-btn-group">
                {categories.map(category => (
                    <button
                        key={category}
                        className={`category-btn ${activeCategory === category ? 'selected' : ''}`}
                        onClick={() => setActiveCategory(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CategoryBar;